import React, { FC } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { Form } from '~/components';
import { usePath } from '~/hooks';
import { inputWidth } from '~/utils/filters';

const Filters: FC<any> = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation('payouts');
  const { changePath, params } = usePath();

  const handleChange = (changed: any, values: Record<string, any>) => {
    changePath({ filter: values });
  };

  return null;
  // eslint-disable-next-line
  return (
    <Form form={form} layout="inline" onValuesChange={handleChange} initialValues={params.filter}>
      <Form.Item name="type">
        <Select
          allowClear
          placeholder={t('type')}
          options={[
            { value: 'INDIVIDUAL', label: t('INDIVIDUAL') },
            { value: 'BUSINESS', label: t('BUSINESS') },
          ]}
          style={inputWidth}
          disabled
        />
      </Form.Item>
    </Form>
  );
};

export default Filters;
